import GpsFixedIcon from '@mui/icons-material/GpsFixed';
import { Box, IconButton, } from '@mui/material';
import { InfoWindow, Marker, MarkerClusterer } from '@react-google-maps/api';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import CustomMarker from '../components/map/CustomMarker';
import Map from '../components/map/Map';
import { IMAGES } from '../util/constants';
import { getDistanceAndDuration, quickSortObjectsByDistance } from '../util/helper';
import { isRenault } from '../util/constants';
import CustomLinearProgress from '../components/CustomLinearProgress';

const NewMap = (
    {
        setDealer,
        filterDealers,
        setFilterDealers,
        dealersWithDistance,
        setDealersWithDistance,
        selectedDealer,
        setSelectedDealer,
        handleFindLocation,
        setHandleFindLocation,
        ...rest
    }) => {
    const loading = useSelector(state => state.loading)

    const form = useSelector(state => state.form)
    const formerDealer = useSelector(state => state.formerDealer)

    const styles = {
        focusButton: {
            width: '40px',
            height: '40px',
            borderRadius: 0,
            backgroundColor: 'white !important',
            color: '#666',
            '&:hover': {
                color: '#111',
                backgroundColor: 'white'
            }
        },
    };

    const [map, setMap] = useState(null);
    const dealers = useSelector(state => state.dealers)

    const [userLocation, setUserLocation] = useState(null);
    const [locs, setLocs] = useState(
        dealers.map((dealer) => {
            return { lat: dealer.latitude, lng: dealer.longitude };
        })
    );

    useEffect(() => {
        if (!dealersWithDistance) {
            setDistance();
        }
    }, [userLocation, map]);

    navigator.geolocation.getCurrentPosition((position) => {
        if (
            position.coords.latitude !== userLocation?.lat ||
            position.coords.longitude !== userLocation?.lng
        ) {
            setUserLocation({
                lat: position.coords.latitude,
                lng: position.coords.longitude
            });
        }
    });

    const setDistance = async () => {
        if ('geolocation' in navigator) {
            let dealersToDistance = [];
            navigator.geolocation.getCurrentPosition(async (position) => {
                // initialize services
                if (!map) return;

                await Promise.all(
                    filterDealers.map(async (item, i) => {
                        let latitude = item.latitude;
                        let longitude = item.longitude;

                        // initialize services
                        // const service = new window.google.maps.DistanceMatrixService();
                        // build request

                        const origin = { lat: position.coords.latitude, lng: position.coords.longitude };
                        const destination = { lat: latitude, lng: longitude };

                        // const request = {
                        //     language: 'tr',
                        //     origins: [origin],
                        //     destinations: [destination],
                        //     travelMode: window.google.maps.TravelMode.DRIVING,
                        //     unitSystem: window.google.maps.UnitSystem.METRIC
                        // };

                        const { distance, duration } = getDistanceAndDuration(origin, destination)

                        // const response = await service.getDistanceMatrix(request);

                        const result = {
                            distance,
                            // duration: duration
                        };
                        dealersToDistance.push({ ...item, ...result });
                    })
                );

                const sorted = quickSortObjectsByDistance(dealersToDistance);
                setDealersWithDistance(sorted);
                setFilterDealers(sorted);
            });
        }
    };

    function mapFitBounds() {
        if (!map) return;

        const bounds = new window.google.maps.LatLngBounds();
        locs.map((loc) => {
            bounds.extend(new window.google.maps.LatLng(loc.lat, loc.lng));
        });
        map.fitBounds(bounds);
    }

    useEffect(() => {
        if (map) {
            mapFitBounds();
        }
    }, [map]);

    useEffect(() => {
        setHandleFindLocation(
            () => {
                return (customLocation) => {
                    if ('geolocation' in navigator) {
                        navigator.geolocation.getCurrentPosition(
                            (position) => {
                                let userLocation = {
                                    lat: filterDealers[0].latitude,
                                    lng: filterDealers[0].longitude
                                };

                                // If customLocation is provided, use that instead
                                if (customLocation) userLocation = customLocation;
                                userLocation.lat += 0.002; // Slight adjustment if customLocation is provided
                                // Center the map at the determined location
                                map?.panTo(userLocation);

                                // Smooth zooming logic
                                const currentZoom = map?.getZoom() || 16;

                                const targetZoom = 16;
                                const zoomStep = (targetZoom - currentZoom) / 10;

                                let currentStep = 0;
                                const zoomInterval = setInterval(() => {
                                    currentStep++;
                                    const newZoom = currentZoom + zoomStep * currentStep;
                                    map?.setZoom(newZoom);
                                    map?.setCenter(userLocation); // Set the center back to the target center
                                    if (currentStep === 10) {
                                        clearInterval(zoomInterval);
                                    }
                                }, 100);
                            },
                            (error) => {
                                console.error('Error getting user location:', error);
                                // You might want to show a fallback location or message to the user here
                            }
                        );
                    } else {
                        console.error('Geolocation is not supported by your browser');
                    }
                };
            }
        )
    }, [filterDealers, map])


    const onMarkerClick = (marker, position) => {
        setSelectedDealer(marker);
        handleFindLocation(position);
    };

    useEffect(() => {
        if (handleFindLocation && map) {
            if (form.dealer) { //Focuses selected dealer from redux
                setSelectedDealer(form.dealer.code)
                handleFindLocation({ lat: form.dealer.latitude, lng: form.dealer.longitude })
            } else if (formerDealer) { //Focuses former dealer
                handleFindLocation({ lat: formerDealer.latitude, lng: formerDealer.longitude })
            }
        }
    }, [map, handleFindLocation])

    const clusterOptions = [
        {
            height: 53,
            url: isRenault ? IMAGES.RENAULT_MARKER : IMAGES.DACIA_MARKER,
            width: 53,
            textColor: 'white',
            textSize: 15
        },
        {
            height: 56,
            url: isRenault ? IMAGES.RENAULT_MARKER : IMAGES.DACIA_MARKER,
            width: 56,
            textColor: 'white',
            textSize: 17
        },
        {
            height: 66,
            url: isRenault ? IMAGES.RENAULT_MARKER : IMAGES.DACIA_MARKER,
            width: 66,
            textColor: 'white',
            textSize: 19
        },
        {
            height: 78,
            url: isRenault ? IMAGES.RENAULT_MARKER : IMAGES.DACIA_MARKER,
            width: 78,
            textColor: 'white',
            textSize: 21
        },
        {
            height: 90,
            url: isRenault ? IMAGES.RENAULT_MARKER : IMAGES.DACIA_MARKER,
            width: 90,
            textColor: 'white',
            textSize: 23
        }
    ]

    return (<Box
        width={1}
        height={1}
        position="relative"
        style={{ height: '26em', marginTop: '8px' }}
    >
        <CustomLinearProgress loading={loading} />
        <Box position="absolute" right={'10px'} top="60px" zIndex="2000">
            <IconButton sx={styles.focusButton} onClick={() => handleFindLocation()} size="large" disabled={!dealersWithDistance}>
                <GpsFixedIcon />
            </IconButton>
        </Box>
        <Map setMap={setMap}>
            <MarkerClusterer styles={clusterOptions}>
                {(clusterer) =>
                    filterDealers.map((dealer) => {

                        return (
                            <Marker
                                key={dealer.code}
                                clusterer={clusterer}
                                position={{ lat: dealer.latitude, lng: dealer.longitude }}
                                onClick={() => {
                                    onMarkerClick(dealer.code, { lat: dealer.latitude, lng: dealer.longitude });
                                }}
                                icon={{
                                    url: isRenault ? IMAGES.RENAULT_MAP_MARKER : IMAGES.DACIA_MAP_MARKER,
                                    scaledSize: { width: 36, height: 36 },
                                }}
                            >
                                {selectedDealer === dealer.code && (
                                    <InfoWindow
                                        onCloseClick={() => setSelectedDealer(null)}
                                        position={{ lat: dealer.latitude, lng: dealer.longitude }}
                                    >
                                        <CustomMarker dealer={dealer} setDealer={setDealer} />
                                    </InfoWindow>
                                )}
                            </Marker>
                        );
                    })
                }
            </MarkerClusterer>
        </Map>
    </Box>
    );
};



export default NewMap;
